import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {
  backNofill,
  chevronRight,
  configurationIc,
} from '../../assets/images/images';
import {DashboardLayout, SecondaryButton} from '../../components';
import * as Actions from '../../store/actions';
import Loader from '../../components/Loader';
import EmptyState from '../../components/EmptyState';
import {useNavigate} from 'react-router-dom';
import Breadcrumbs from 'components/BreadCrumbs';
import {PAGES_URL} from 'helpers/constants';

function DevelopersWebhook({webhook: {portalUrl}}) {
  const [loading, setLoading] = useState(
    portalUrl === null ? true : Boolean(portalUrl?.entity?.portal_url),
  );

  const navigate = useNavigate();

  useEffect(() => {
    if (loading && portalUrl === null) {
      setTimeout(() => setLoading(false), 3000);
    }
  }, [loading, portalUrl]);

  return (
    <DashboardLayout
      breadCrumbs={
        <p className="text-tiny font-normal text-deepBlue">Webhooks</p>
      }
    >
      <div className="flex items-center min-h-[52px] py-2 flex-wrap gap-3 justify-between mr-[-24px] ml-[-32px] px-8 border border-transparent border-b-[#E4E4E6]">
        <Breadcrumbs
          items={[
            {
              label: 'Webhooks',
              path: PAGES_URL.DEVELOPERS_WEBHOOK,
            },
            {label: 'Webhook details'},
          ]}
        />
      </div>
      <section className="flex flex-col">
        {loading ? <Loader /> : null}
        {portalUrl && Boolean(portalUrl?.entity?.portal_url) ? (
          <iframe
            src={`${portalUrl && portalUrl?.entity?.portal_url}` || ''}
            height={750}
            width="auto"
            onLoad={() => setLoading(false)}
            className="min-h-screen"
          />
        ) : (
          <>
            {!loading && (
              <EmptyState
                noBtn
                body="You do not have any subscription details to display"
                customBtn={
                  <SecondaryButton
                    onClick={() => navigate('/developers/webhooks')}
                    buttonText="Go back"
                    btnHeight="h-[24px]"
                    yPadding=""
                    src={backNofill}
                    leftImg
                    className="flex items-center pr-6"
                  />
                }
                height={64}
              />
            )}
          </>
        )}
      </section>
    </DashboardLayout>
  );
}
export default connect(state => state, Actions)(DevelopersWebhook);
